export const PRIMARY_TYPE_BUTTON = 'primary';

export const SECONDARY_TYPE_BUTTON = 'secondary';

export const TERTIARY_TYPE_BUTTON = 'tertiary';

export const MEDIUM_SIZE_BUTTON = 'M';

export const SMALL_SIZE_BUTTON = 'S';